import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Otp } from '@/features/auth/otp'

const searchSchema = z.object({
  email: z.string().email().optional(),
  redirect: z.string().optional(),
  type: z.enum(['sign-in', 'email-verification', 'forget-password']).optional(),
})

export const Route = createFileRoute('/otp')({
  component: Otp,
  validateSearch: searchSchema,
})
